import {SHOW_STATE} from '../action-creators/get-agreement';
import {TOGGLE_ON} from '../action-creators/get-agreement';

const agreementReducer = (state = {show:true, toggleOn:true},action) => {
     switch(action.type){
        case SHOW_STATE:
             //console.log(`${SHOW_STATE} reducerss state:${JSON.stringify(state)} payload:${JSON.stringify(action.payload)}`);
             return action.payload;;
        case TOGGLE_ON:
             //console.log(`${TOGGLE_ON} reducerss state:${JSON.stringify(state)} payload:${JSON.stringify(action.payload)}`);
             return action.payload;              
         default:
             //console.log(`${SHOW_STATE} reducer state:${JSON.stringify(state)}`);
             return state;         
        }
}

export default agreementReducer;